import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

// Attach bearer token (admin) from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('pn_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const absoluteUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
};

export const ProductsAPI = {
  list: (params = {}) => api.get('/products', { params }).then((r) => r.data),
  get: (id) => api.get(`/products/${id}`).then((r) => r.data),
};

export const TestimonialsAPI = {
  list: () => api.get('/testimonials').then((r) => r.data),
};

export const BlogAPI = {
  list: () => api.get('/blog').then((r) => r.data),
  get: (slug) => api.get(`/blog/${slug}`).then((r) => r.data),
  createLead: (data) => api.post('/blog/leads', data).then((r) => r.data),
};

export const ContactAPI = {
  create: (data) => api.post('/contact', data).then((r) => r.data),
};

export const QuoteAPI = {
  create: (data) => api.post('/quote-requests', data).then((r) => r.data),
};

export const AuthAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }).then((r) => r.data),
  me: () => api.get('/auth/me').then((r) => r.data),
};

export const AdminAPI = {
  listProducts: () => api.get('/admin/products').then((r) => r.data),
  getProduct: (id) => api.get(`/admin/products/${id}`).then((r) => r.data),
  createProduct: (data) => api.post('/admin/products', data).then((r) => r.data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data).then((r) => r.data),
  setProductStatus: (id, status) => api.patch(`/admin/products/${id}/status`, null, { params: { status } }).then((r) => r.data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`).then((r) => r.data),
  listTestimonials: () => api.get('/admin/testimonials').then((r) => r.data),
  createTestimonial: (data) => api.post('/admin/testimonials', data).then((r) => r.data),
  updateTestimonial: (id, data) => api.put(`/admin/testimonials/${id}`, data).then((r) => r.data),
  deleteTestimonial: (id) => api.delete(`/admin/testimonials/${id}`).then((r) => r.data),
  reorderTestimonials: (ids) => api.post('/admin/testimonials/reorder', { ids }).then((r) => r.data),
  // Blog
  listBlog: () => api.get('/admin/blog').then((r) => r.data),
  getBlogPost: (id) => api.get(`/admin/blog/${id}`).then((r) => r.data),
  createBlogPost: (data) => api.post('/admin/blog', data).then((r) => r.data),
  updateBlogPost: (id, data) => api.put(`/admin/blog/${id}`, data).then((r) => r.data),
  setBlogPublished: (id, published) => api.patch(`/admin/blog/${id}/publish`, null, { params: { published } }).then((r) => r.data),
  deleteBlogPost: (id) => api.delete(`/admin/blog/${id}`).then((r) => r.data),
  // Leads & contacts
  listBlogLeads: () => api.get('/admin/blog-leads').then((r) => r.data),
  listContacts: () => api.get('/admin/contacts').then((r) => r.data),
  listQuotes: () => api.get('/admin/quote-requests').then((r) => r.data),
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
};

export default api;
